import { NEWS_TYPES, ROUTER_NAMES } from '../constants';
import store from '../store';
import Nav from '../components/default/Nav';
import Footer from '../components/default/Footer';
import routeChecks from '../utils/routeChecks';

export default [
  {
    path: '/home',
    name: ROUTER_NAMES.HOME,
    components: {
      nav: Nav,
      footer: Footer,
      default: () => import('../views/Home.vue')
    }
  },
  {
    path: '/contact',
    name: ROUTER_NAMES.CONTACT,
    components: {
      nav: Nav,
      footer: Footer,
      default: () => import('../views/contact/Contact.vue')
    }
  },
  {
    path: '/register',
    name: ROUTER_NAMES.REGISTRATION,
    components: {
      nav: Nav,
      footer: Footer,
      default: () => import('../views/registration/RegistrationForm.vue')
    },
    beforeEnter: (to, from, next) => {
      routeChecks.onlyNotLogged(next);
    }
  },
  {
    path: '/register-success',
    name: ROUTER_NAMES.REGISTRATION_SUCCESS,
    components: {
      nav: Nav,
      footer: Footer,
      default: () => import('../views/registration/RegistrationSuccess.vue')
    },
    beforeEnter: (to, from, next) => {
      routeChecks.onlyNotLogged(next);
    }
  },
  {
    path: '/login',
    name: ROUTER_NAMES.LOGIN,
    components: {
      nav: Nav,
      footer: Footer,
      default: () => import('../views/login/LoginForm.vue')
    },
    beforeEnter: (to, from, next) => {
      routeChecks.onlyNotLogged(next);
    }
  },
  {
    path: '/verification-email',
    name: ROUTER_NAMES.VERIFICATION_EMAIL,
    components: {
      nav: Nav,
      footer: Footer,
      default: () => import('../views/login/VerifyEmail')
    },
    beforeEnter: (to, from, next) => {
      routeChecks.onlyNotLogged(next);
    }
  },
  {
    path: '/verification-email-success',
    name: ROUTER_NAMES.VERIFY_EMAIL_SUCCESS,
    components: {
      nav: Nav,
      footer: Footer,
      default: () => import('../views/login/VerifyEmailSuccess')
    },
    beforeEnter: (to, from, next) => {
      routeChecks.onlyNotLogged(next);
    }
  },
  {
    path: '/verify-email',
    name: ROUTER_NAMES.VERIFY_EMAIL,
    components: {
      nav: Nav,
      footer: Footer,
      default: () => import('../views/login/VerifyEmailToken')
    },
    beforeEnter: (to, from, next) => {
      routeChecks.onlyNotLogged(next);
    }
  },
  {
    path: '/verify-email-token-expired',
    name: ROUTER_NAMES.VERIFY_EMAIL_EXPIRED,
    components: {
      nav: Nav,
      footer: Footer,
      default: () => import('../views/login/VerifyEmailError')
    },
    beforeEnter: (to, from, next) => {
      routeChecks.onlyNotLogged(next);
    }
  },
  {
    path: '/logout',
    name: ROUTER_NAMES.LOGOUT,
    components: {
      nav: Nav,
      footer: Footer,
    },
    beforeEnter: (to, from, next) => {
      const user = store.getters.user;
      if (Object.keys(user).length > 0) {
        store.commit('setToken', {
          access_token: null
        });
        store.commit('setInfo', {});
      }

      next({
        name: 'home',
        query: { p: 1 }
      });
    }
  },
  {
    path: '/news/create',
    name: ROUTER_NAMES.NEWS_CREATE,
    components: {
      nav: Nav,
      footer: Footer,
      default: () => import('../views/editor/CreateNews.vue')
    },
    beforeEnter: (to, from, next) => {
      routeChecks.onlyEditor(next);
    }
  },
  {
    path: '/news/:slug',
    name: ROUTER_NAMES.NEWS,
    components: {
      nav: Nav,
      footer: Footer,
      default: () => import('../views/news/NewsDetail.vue')
    }
  },
  {
    path: '/news-unpublished/:slug',
    name: ROUTER_NAMES.NEWS_UNPUBLISHED,
    components: {
      nav: Nav,
      footer: Footer,
      default: () => import('../views/editor/UnpublishedNewsDetail.vue')
    },
    beforeEnter: (to, from, next) => {
      routeChecks.onlyEditor(next);
    }
  },
  {
    path: '/news-list/unpublished',
    name: ROUTER_NAMES.NEWS_UNPUBLISHED_LIST,
    components: {
      nav: Nav,
      footer: Footer,
      default: () => import('../views/editor/UnpublishedNewsList.vue')
    },
    beforeEnter: (to, from, next) => {
      routeChecks.onlyEditor(next);
    }
  },
  {
    path: '/news-list/:type',
    name: ROUTER_NAMES.NEWS_LIST,
    components: {
      nav: Nav,
      footer: Footer,
      default: () => import('../views/news/NewsList.vue')
    },
    beforeEnter: (to, from, next) => {
      const type = to.params.type;
      if (type !== NEWS_TYPES.BEST && type !== NEWS_TYPES.LATEST) {
        next('notFound');
      } else {
        next();
      }
    }
  },
  {
    path: '/posolstva',
    name: ROUTER_NAMES.NEWS_MESSAGES_LIST,
    components: {
      nav: Nav,
      footer: Footer,
      default: () => import('../views/news/MessagesList.vue')
    }
  },
  {
    path: '/posolstva/:slug',
    name: ROUTER_NAMES.NEWS_MESSAGES_DETAIL,
    components: {
      nav: Nav,
      footer: Footer,
      default: () => import('../views/news/MessageDetail.vue')
    }
  },
  {
    path: '/news/:slug/edit',
    name: ROUTER_NAMES.NEWS_EDIT,
    components: {
      nav: Nav,
      footer: Footer,
      default: () => import('../views/editor/EditNews.vue')
    },
    beforeEnter: (to, from, next) => {
      routeChecks.onlyEditor(next);
    }
  },
  {
    path: '/page/:parent/:parentSlug/create',
    name: ROUTER_NAMES.PAGE_CREATE,
    components: {
      nav: Nav,
      footer: Footer,
      default: () => import('../views/editor/CreatePage.vue')
    },
    beforeEnter: (to, from, next) => {
      routeChecks.onlyEditor(next);
    }
  },
  {
    path: '/page/:parentSlug/create',
    name: ROUTER_NAMES.PAGE_CREATE_PARENT,
    components: {
      nav: Nav,
      footer: Footer,
      default: () => import('../views/editor/CreatePage.vue')
    },
    beforeEnter: (to, from, next) => {
      routeChecks.onlyEditor(next);
    }
  },
  {
    path: '/page/:parent',
    name: ROUTER_NAMES.PARENT_PAGE,
    components: {
      nav: Nav,
      footer: Footer
    },
    beforeEnter: (to, from, next) => {
      next(false);
    }
  },
  {
    path: '/page/:parent/:slug',
    name: ROUTER_NAMES.PAGE,
    components: {
      nav: Nav,
      footer: Footer,
      default: () => import('@/modules/pages/views/Page.vue')
    }
  },
  {
    path: '/page/:parent/:slug/edit',
    name: ROUTER_NAMES.PAGE_EDIT,
    components: {
      nav: Nav,
      footer: Footer,
      default: () => import('../views/editor/EditPage.vue')
    },
    beforeEnter: (to, from, next) => {
      routeChecks.onlyEditor(next);
    }
  },
  {
    path: '/images',
    name: ROUTER_NAMES.SLIDER_IMAGES,
    components: {
      nav: Nav,
      footer: Footer,
      default: () => import('../views/editor/SliderImages.vue')
    },
    beforeEnter: (to, from, next) => {
      routeChecks.onlyEditor(next);
    }
  },
  {
    path: '/images/create',
    name: ROUTER_NAMES.SLIDER_IMAGES_CREATE,
    components: {
      nav: Nav,
      footer: Footer,
      default: () => import('../views/editor/CreateSliderImage.vue')
    },
    beforeEnter: (to, from, next) => {
      routeChecks.onlyEditor(next);
    }
  },
  {
    path: '/images/:id',
    name: ROUTER_NAMES.SLIDER_IMAGES_EDIT,
    components: {
      nav: Nav,
      footer: Footer,
      default: () => import('../views/editor/EditSliderImage.vue')
    },
    beforeEnter: (to, from, next) => {
      routeChecks.onlyEditor(next);
    }
  },
  {
    path: '/forgot-password',
    name: ROUTER_NAMES.FORGOT_PASSWORD,
    components: {
      nav: Nav,
      footer: Footer,
      default: () => import('../views/login/ForgotPassword.vue')
    },
    beforeEnter: (to, from, next) => {
      routeChecks.onlyNotLogged(next);
    }
  },
  {
    path: '/forgot-password/success',
    name: ROUTER_NAMES.FORGOT_PASSWORD_SUCCESS,
    components: {
      nav: Nav,
      footer: Footer,
      default: () => import('../views/login/ForgotPasswordSuccess.vue')
    },
    beforeEnter: (to, from, next) => {
      routeChecks.onlyNotLogged(next);
    }
  },
  {
    path: 'user/profile',
    name: ROUTER_NAMES.USER_PROFILE,
    components: {
      nav: Nav,
      footer: Footer,
      default: () => import('../views/user/Profile.vue')
    },
    beforeEnter: (to, from, next) => {
      routeChecks.onlyLogged(next);
    }
  },
  {
    path: 'user/registrations',
    name: ROUTER_NAMES.USER_ACTIVE_REGISTRATION,
    components: {
      nav: Nav,
      footer: Footer,
      default: () => import('../views/user/EventRegistrations.vue')
    },
    beforeEnter: (to, from, next) => {
      routeChecks.onlyLogged(next);
      routeChecks.onlyIfEvent(next);
    }
  },
  {
    path: 'user/events',
    name: ROUTER_NAMES.USER_AVAILABLE_EVENTS,
    components: {
      nav: Nav,
      footer: Footer,
      default: () => import('../views/user/AvailableEvents.vue')
    },
    beforeEnter: (to, from, next) => {
      routeChecks.onlyLogged(next);
      routeChecks.onlyIfEvent(next);
    }
  },
  {
    path: 'user/events/registration/success',
    name: ROUTER_NAMES.SUBSCRIBE_SUCCESS,
    components: {
      nav: Nav,
      footer: Footer,
      default: () => import('../views/user/EventRegistrationSuccess.vue')
    },
    beforeEnter: (to, from, next) => {
      routeChecks.onlyLogged(next);
    }
  },
  {
    path: 'user/events/:eventId',
    name: ROUTER_NAMES.USER_EVENT_REGISTER,
    components: {
      nav: Nav,
      footer: Footer,
      default: () => import('../views/user/EventRegistrationForm.vue')
    },
    beforeEnter: (to, from, next) => {
      routeChecks.canRegister(next).onlyLogged(next);
    }
  },
  {
    path: 'reset-password',
    name: ROUTER_NAMES.RESET_PASSWORD,
    components: {
      nav: Nav,
      footer: Footer,
      default: () => import('../views/login/ResetPassword.vue')
    },
    beforeEnter: (to, from, next) => {
      routeChecks.onlyNotLogged(next);
    }
  },
];
